export default {
	install (Vue, options) {
		if (this.installed) {
			return
		}

		this.installed = true

		Vue.prototype.$modal = new Vue() // ModalsBus

		Vue.prototype.$modal.open = function (name, options) {
			this.$emit('modal-open', name, options)
		}
	}
}
